import { Box, Grid, MenuItem } from '@mui/material';
import { useSelector } from 'react-redux';
import ContentLoader from '../../subcomponents/ContentLoader';
import AdminSettingBool from '../inputs/AdminSettingBool';
import AdminSettingSelect from '../inputs/AdminSettingSelect';

export default function AppSettingsTab() {
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { appSettings, appSettingsStatus } = useSelector((state) => state.settings.app);

    return (
        <ContentLoader
            successCondition={appSettingsStatus === "success"}
            errorCondition={appSettingsStatus === "failed"}
            content={
                <Box sx={{ width: 1 }}>
                    <Grid container spacing={1}>
                        <AdminSettingSelect
                            settingsType={"app"}
                            settingKey={"App_Version"}
                            settingDefaultValue={appSettings?.appVersion}
                            formLabel={resourceFinal[appLanguage].admin.APP_VERSION}
                            formText={resourceFinal[appLanguage].admin.APP_VERSION_HTEXT}
                            xsSize={12}
                            menuItems={[
                                <MenuItem value={"1"}>{resourceFinal[appLanguage].admin.APP_VERSION_1}</MenuItem>,
                                <MenuItem value={"2"}>{resourceFinal[appLanguage].admin.APP_VERSION_2}</MenuItem>
                            ]}
                        />
                        <AdminSettingBool
                            settingsType={"app"}
                            settingKey={"App_WintersportModeEnabled"}
                            settingDefaultValue={appSettings?.wintersportModeEnabled}
                            formLabel={resourceFinal[appLanguage].admin.APP_WINTERSPORT_MODE}
                            formText={resourceFinal[appLanguage].admin.APP_WINTERSPORT_MODE_HTEXT}
                            controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                            xsSize={12}
                        />
                        <AdminSettingBool
                            settingsType={"app"}
                            settingKey={"Notification_Enabled"}
                            settingDefaultValue={appSettings?.notificationEnabled}
                            formLabel={resourceFinal[appLanguage].admin.APP_NOTIFS_ON_HEAD}
                            formText={resourceFinal[appLanguage].admin.APP_NOTIFS_ON_HTEXT}
                            controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                            xsSize={6}
                        />
                        <AdminSettingBool
                            settingsType={"app"}
                            settingKey={"Notification_Required"}
                            settingDefaultValue={appSettings?.notificationRequired}
                            formLabel={resourceFinal[appLanguage].admin.APP_NOTIFS_REQ}
                            formText={resourceFinal[appLanguage].admin.APP_NOTIFS_REQ_HTEXT}
                            controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                            disabledCondition={!appSettings?.notificationEnabled}
                            xsSize={6}
                        />
                        <AdminSettingBool
                            settingsType={"app"}
                            settingKey={"App_ShowSchedulePeriod"}
                            settingDefaultValue={appSettings?.showSchedulePeriod}
                            formLabel={resourceFinal[appLanguage].admin.APP_SHOW_PERIOD_SCHEDULE}
                            formText={resourceFinal[appLanguage].admin.APP_SHOW_PERIOD_SCHEDULE_HTEXT}
                            controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                            xsSize={12}
                        />
                        <AdminSettingSelect
                            settingsType={"app"}
                            settingKey={"App_ActivityProgressOrder"}
                            settingDefaultValue={appSettings?.activityProgressOrder}
                            formLabel={resourceFinal[appLanguage].admin.APP_ACTIVITY_PROGRESS_ORDER}
                            formText={resourceFinal[appLanguage].admin.APP_ACTIVITY_PROGRESS_ORDER_HTEXT}
                            xsSize={12}
                            menuItems={[
                                <MenuItem value={"Default"}>Default</MenuItem>,
                                <MenuItem value={"Name"}>Name</MenuItem>,
                                <MenuItem value={"Moment"}>Moment</MenuItem>
                            ]}
                        />
                    </Grid>
                </Box>
            }
        />
    );
}
